import { render, staticRenderFns } from "./SeminarArchive.vue?vue&type=template&id=1738ca21"
import script from "./SeminarArchive.vue?vue&type=script&lang=js"
export * from "./SeminarArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports